import React, { useEffect, useState } from "react";
import { MultiSelect } from "react-multi-select-component";

const DropdownMultiSelect = ({
  options = [],
  placeholder = "Select",
  allItemsAreSelectedText = "All items are selected",
  selectAllText = "Select all",
  width = "tw-w-full",
  valueKey = "value",
  labelKey = "label",
  setSelectedItems,
  setCurrentPage,
}) => {
  const [selected, setSelected] = useState([]);

  const transformedOptions = Array.isArray(options)
    ? options.map((option) => ({
        value: option[valueKey],
        label: option[labelKey],
      }))
    : [];

  useEffect(() => {
    if (setSelectedItems) {
      setSelectedItems(selected);
      setCurrentPage(1);
    }
  }, [selected, setSelectedItems]);

  return (
    <div>
      <MultiSelect
        className={width}
        options={transformedOptions}
        value={selected}
        onChange={setSelected}
        labelledBy="Select"
        overrideStrings={{
          selectSomeItems: placeholder,
          allItemsAreSelected: allItemsAreSelectedText,
          selectAll: selectAllText,
        }}
      />
    </div>
  );
};

export default DropdownMultiSelect;
